import { useState } from "react";
import { AmazonApi, AmazonCallbackGetRequest } from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiLwaCallback = () => {
  const [success, setSuccess] = useState<boolean | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const callLwaCallback = async (
    code: string,
    state: string,
    selling_partner_id: string,
    env?: string
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const api = new AmazonApi(config);

      const req: AmazonCallbackGetRequest = {
        code: code,
        state: state,
        env: env,
        sellingPartnerId: selling_partner_id,
      };

      const response = await api.amazonCallbackGet(req);
      setSuccess(response);
      return response;
    } catch (err) {
      console.error(err);
      setError("Amazon連携の処理に失敗しました");
      setSuccess(false);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { callLwaCallback, success, error, isLoading };
};
